import { USERMANAGE } from '../actionTypes'

const initialState = {
  userRoleOptions: [],
  userAreaOptions: [],
  userEntityOptions: [],
  searchRoleOptions: [],
  userTypeOptions: [
    {
      label: '平台用户',
      value: 0,
    },
    {
      label: '实体用户',
      value: 1,
    },
  ],
  businessTypeOptions: [
    {
      label: '单车',
      value: 1,
    },
    {
      label: '电单车',
      value: 2,
    },
    {
      label: '双业务线',
      value: 3,
    },
  ],
  userList: [],
  total: [],
}

export default function response(state = initialState, action: Action) {
  switch (action.type) {
    case USERMANAGE.UPDATE_STATE:
      return { ...state, ...action.payload }
    default:
      return state
  }
}
